import { styled } from "@mui/material/styles";

export const HelpTooltipContainer = styled("div")(({ theme }) => ({
  width: "375px",
  color: "#FEFEFE",
  padding: "24px 12px",
  "& > img": {
    maxWidth: "100%",
    height: "auto",
    borderRadius: "6px",
    border: "rgba(255,255,255,0.2) 1px solid",
  },
  "& .close": {
    position: "absolute",
    right: 10,
    top: 24,
    background: "transparent",
    border: 0,
    cursor: "pointer"
  },
  "& .tooltip-content": {
    "& h2": {
      color: "#01ECFF",
      fontSize: "16px",
      fontWeight: "600",
      margin: "0 0 15px 0",
    },
    "& p": {
      fontSize: "12px",
      fontWeight: "400",
    },
  },
  "& .tooltip-actions": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .counter": {
      color: "#D5D7DA",
      fontSize: "16px",
    },
    "& .buttons": {
      display: "flex",
      gap: "10px",
    },
  },
}));
